<template>
  <v-dialog
    v-model='dialog'
    persistent
    scrollable
    max-width="80%"
  >
    <v-card  min-height="500px" max-height="500px">
      <v-card color="blue">
        <v-card-title flat class='white--text title py-0'>{{ 'SELECT_BANK' | translate}}
          <v-spacer></v-spacer>
          <v-btn
            icon
            class="text-none"
            color="white"
            flat
            @click="resetNear()"
          >
            <v-icon>
              clear
            </v-icon>
          </v-btn>
        </v-card-title>
        <span v-if="warning">{{warnMessage}}</span>
      </v-card>
      <v-container class="pt-4">
        <v-card-text style="min-height: 350px; max-height: 350px">
          <v-layout row class="underlineheadlinetable">
            <v-flex xs12>
              <v-card flat>
                <v-card-title class="pb-0 text-uppercase caption grey--text">{{ 'NAME_BANK_TABLE' | translate}}</v-card-title>
                <v-card-text v-html="headItem.name" class="text-xs-left pt-0 pb-1"></v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card flat>
                <v-card-title class="pb-0 text-uppercase caption grey--text">{{ 'CREFO_BANK_TABLE' | translate}}</v-card-title>
                <v-card-text v-html="headItem.crefoNr" class="text-xs-left pt-0 pb-1"></v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout wrap style="padding: 0px;">
            <v-flex id="nbdflex" md12 v-if="false">
              <FixedTableIE :heightSub="100" clickEventName="clickOnNearestItem" ref="dnbTable"
                            :currency="currentCurrency" :selected="selected" v-if="(pgresults != null)"
                            :tableConfig='tableConfig' :tableNotComplete="tableNotComplete" :headers="headersDialog"
                            :items="pgresults" class="colorrows"></FixedTableIE>
            </v-flex>

            <v-flex md12>
              <v-data-table
                :headers="headersDialog"
                :items="tableList"
                hide-actions
                :key="keyIndex"
                :pagination.sync="pagination"
                item-key="id"
              >
                <template v-slot:no-data>
                  &nbsp;
                  <span style="text-align: left"></span>
                </template>

                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      class="text-uppercase"
                      v-for="header in props.headers"
                      :key="header.text"
                      :colspan="getColSpan(header)"
                      :class="['column sortable ' + getHeadTDClass(header), pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSortDouble(header.value)"
                    >
                      {{ header.text }}
                      <v-icon small>arrow_upward</v-icon>
                    </th>
                  </tr>
                </template>
                <!--
                <template v-slot:expand="props">
                  <v-layout wrap style="padding-left: 20px;">
                    <v-flex md12>
                      <v-data-table
                        hide-actions
                        hide-headers
                        :headers="headersDialog"
                        :items="clonedData[props.item[0].dbKey]"
                        :pagination.sync="pagination"
                        :expand="expand"
                        item-key="id"
                      >
                        <template slot="headers" slot-scope="props">
                          <tr>
                            <th
                              v-for="header in props.headers"
                              :key="header.text"
                              :style="'width:' + header.meta.width + '0px'"
                              :class="['column sortable ' + getHeadTDClass(header), pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                              @click="changeSortDouble(header.value)"
                            >
                              {{ header.text }}
                              <v-icon small>arrow_upward</v-icon>
                            </th>
                          </tr>
                        </template>
                        <template v-slot:items="props">
                          <tr @click="onSelectItem(props.item)" class="handpointer">
                            <td :class="getCellClass(header, props.item)" v-for="header in headersDialog" :key="header.id">
                              {{ getValue(props.item, header)}}
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </template>
                -->
                <template v-slot:items="props">
                  <tr class="handpointer">
                    <!--
                    <td>
                      <v-icon v-if="!props.item.isAnkerBank" color="red" @click="deleteItem(props.item)">clear</v-icon>
                      <v-icon :title="props.item.alertText" :text="props.item.alertText" v-if="props.item.hasAlert"
                              color="yellow">warning
                      </v-icon>
                    </td>
                    -->
                    <td :class="getCellClass(header, props.item)" v-for="header in headersDialog" :key="header.id">
                      <span v-if="header.meta.id !== 'year'">{{ getValue(props.item, header)}}</span>
                      <v-flex v-if="header.meta.id === 'year'">
                        <v-btn small color="#8ACAC1" depressed dark class="font-weight-bold ml-0" @click="onSelectItem(props.item)">{{getValue(props.item, header)}}</v-btn>
                        <v-btn small color="#7F7F7F" class="font-weight-bold ml-0" outline v-for="(yItem, i) in props.item.subList" @click="onSelectItem(yItem)" v-bind:key="i" >{{yItem.meta.year}}</v-btn>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn v-if="props.item.subListMenu.length > 0" small color="#7F7F7F" class="font-weight-bold ml-0" outline v-model="moreyears" @click="" v-on="on"> ...&nbsp;&nbsp;<v-icon small color="#7F7F7F">fa fa-caret-down</v-icon> </v-btn>
                          </template>
                          <v-list>
                            <v-list-tile
                              v-for="(item, index) in props.item.subListMenu"
                              :key="index"
                              @click="onSelectItem(item)"
                            >
                              <v-list-tile-title>{{ item.meta.year }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-flex>
                     <!-- <v-flex v-if="header.meta.id === 'year'">
                        <v-btn small color="#7F7F7F" outline v-for="(yItem, i) in props.item.subList" @click="onSelectItem(yItem)" v-bind:key="i" >{{yItem.meta.year}}</v-btn>
                      </v-flex>-->
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue" dark class="text-none"
          @click="openWithoutBalance()"
        >
          {{ 'BUTT_WITHOUT_BAL' | translate}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import FixedTableIE from './../../tables/EasyTableIE'

  var _ = require('lodash')
  export default {
    name: 'DialogNearestBanks',
    components: {FixedTableIE},
    data() {
      return {
        moreyearsitems: [
          { title: '2012' },
          { title: '2013' },
          { title: '2014' },
          { title: '2015' }
        ],
        moreyears: true,
        dialog: false,
        headItem: {},
        clonedData: [],
        warning: false,
        keyIndex: 0,
        currentCurrency: 1,
        warnMessage: '',
        pgresults: [],
        selected: false,
        source: null,
        newestYear: [],
        aaNr: null,
        expand: false,
        rk: null,
        pagination: {
          rowsPerPage: 50,
          descending: false,
          sortBy: 'AA'
        },
        year: null,
        rkList: [],
        sourceList: [],
        yearList: [],
        aaList: [],
        tableList: [],
        labelSource: 'Quelle',
        labelRK: 'Rechtskreis',
        labelYear: 'Jahr',
        defBalance: {},
        labelAbschluss: 'Abschlussart',
        tableNotComplete: false,
        akresultsDialog: [],
        headersDialog: [],
        'tableConfig': {
          selection: false,
          isClickable: true,
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
          },
          rows: {
            rowClass: 'rowEIE'
          }
        }
      }
    },
    computed: {
    },
    methods: {
      getColSpan : function(header) {
        if (header.value === '0') return 1
        return 1
      },
      getFilteredItems: function () {
        // console.log('this.getFilteredItems()')
        this.tableList = []
        for (var rowIndex in this.pgresults) {
          var row = this.pgresults[rowIndex]
          this.tableList.push(row)

          row.root = true
          row.hasExpand = false
          row.subList = []
          row.subListMenu = []
          if (this.clonedData[row.dbKey].length > 0) {
            var bString = Vue.prototype.$api.balanceToString(row.meta.balance)

            for (var cIndex in this.clonedData[row.dbKey]) {
              var item = this.clonedData[row.dbKey][cIndex]
              var cString = Vue.prototype.$api.balanceToString(item.meta.balance)
              if (bString === cString) continue
              item.root = false
              row.hasExpand = true
              if (row.expanded) {
                this.tableList.push(item)
              }
              if (row.subList.length > 1) {
                row.subListMenu.push(item)
              } else {
                row.subList.push(item)
              }

              // console.log('log', item)
            }
          }
        }
        // console.log('this.getFilteredItems()', this.tableList)
      },
      doExpand: function (props) {
        props.item.expanded = !props.item.expanded;
        // this.keyIndex++;
        this.getFilteredItems()
      },
      openTable: function () {
        this.getFilteredItems()
        if (this.$refs.dnbTable && this.$refs.dnbTable.updateData) {
          var width = $('#nbdflex').width()
          this.$refs.dnbTable.setFixedWidth(width)
          this.$refs.dnbTable.updateData(this.pgresults, width)
        }
      },
      changeSortDouble (column) {
        Vue.prototype.$api.debug('change sort double', column)
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getHeadTDClass (head) {
        var cClass = ''
        if (head) {
          cClass = cClass + ' head' + head.id
          if (head.isExtraField) {
            cClass = cClass + ' head_Extra'
          }
        }
        var align = this.convertAlignToClass(head.meta.align)
        if (align) {
          cClass += ' ' + align
        }
        return cClass
      },
      setModuleId: function (moduleId) {
        this.idModule = moduleId
      },

      getCellClass (head, item) {
        var css = ' '

        if (!head) return css

        if (head.value === 'year') {

        } else if (head.value === 'name') {

        } else if (head.value === 'country') {

        } else if (head.value === 'abschlussart') {

        } else if (head.value === 'rechtskreis') {

        } else if (head.value === 'branch') {

        } else if (head.value === 'balanceSum') {
          css += ' right'
        } else if (head.isExtraField) {
          css += ' right'
        }
        var align = this.convertAlignToClass(head.meta.align)
        if (align) {
          css += ' ' + align
        }

        return css
      },
      convertAlignToCss (align) {
        if (align === 'L') align = 'left'
        if (align === 'C') align = 'center'
        if (align === 'R') align = 'right'
        return align
      },
      convertAlignToClass (align) {
        if (align === 'L') align = 'textleft'
        if (align === 'C') align = 'textcenter'
        if (align === 'R') align = 'textright'
        return align
      },
      toMinString: function (val) {
        if (!val) val = '0000'
        if ((val + '').length < 4) {
          var cnt = 4 - (val + '').length
          for (var i = 0; i < cnt; i++) {
            val = val + '0'
          }
        }
        return val
      },
      open: function (data) {
        this.headers = []


        let rkList = {}
        let sourceList = {}
        let yearList = {}
        let aaList = {}

        _.drop(this.newestYear, this.newestYear.length)

        for (var rowIndex in data.table.rows) {
          var row = data.table.rows[rowIndex]
          row.expanded = false
          row.root = true


          var balance = row.balance

          var key = '_rk' + this.toMinString(-1.0 * balance.rkNr) + '_so' + this.toMinString(balance.source) + '_aa' + this.toMinString(balance.aaNr)
          row.cells[0].dbKey = key
          row.year = balance.year
          row.dbKey = key
          this.defBalance = balance
          if (balance.rkNr) rkList[balance.rkNr] = balance.rkNr
          if (balance.source) sourceList[balance.source] = balance.source
          if (balance.year) yearList[balance.year] = balance.year
          if (balance.aaNr) aaList[balance.aaNr] = balance.aaNr
        }
        data.table.rows = _.orderBy(data.table.rows, ['dbKey', 'year'], ['desc', 'desc']);

        this.clonedData = {}
        var result = Vue.prototype.$api.prepareWaimeaTable(data.table)
        for (var rowIndex in result.rows) {
          var row = result.rows[rowIndex]
          result.rows[rowIndex].id = rowIndex
          row.dbKey = row[0].dbKey
          row.false

          if (this.clonedData[row.dbKey]) {
            this.clonedData[row.dbKey].push(row)
          } else {
            this.clonedData[row.dbKey] = []
            this.clonedData[row.dbKey].push(row)
          }
        }


        var deleteMe = []
        var oldKey = -1
        for (var rowIndex in data.table.rows) {
          var row = data.table.rows[rowIndex]
          row.id = rowIndex
          if (oldKey != -1) {
            if (row.dbKey === oldKey) {
              deleteMe.push(row)
            }
          }
          oldKey = row.dbKey
        }
        _.pullAllBy(data.table.rows, deleteMe)

        var result = Vue.prototype.$api.prepareWaimeaTable(data.table)

        for (var rowIndex in result.rows) {
          var row = result.rows[rowIndex]
          result.rows[rowIndex].id = rowIndex
        }

        this.pgresults = result.rows
        this.headersDialog = this.filterHeader(result.headers)


        this.rkList = []
        this.sourceList = []
        this.yearList = []
        var gblRKList = Vue.prototype.storage.getRechtskreise()
        var gblSourceList = Vue.prototype.storage.getSourcesList()
        var gblAbschlussart = Vue.prototype.storage.getAbschlussartList()
        for (var i in Object.keys(rkList)) {
          var key = '' + Object.values(rkList)[i]
          var index = _.findIndex(gblRKList, function (o) {
            return o.id === key;
          });
          if (index !== -1) {
            this.rkList.push(gblRKList[index])
          }
        }
        for (var i in Object.keys(sourceList)) {
          var key = Object.values(sourceList)[i]
          var index = _.findIndex(gblSourceList, function (o) {
            return o.id === '' + key;
          }) * 1;
          if (index !== -1) {
            this.sourceList.push(gblSourceList[index])
          }
        }
        for (var i in Object.keys(yearList)) {
          var year = '' + Object.values(yearList)[i]
          this.yearList.push({
            id: year,
            title: year
          })
        }
        var language = Vue.prototype.$config.languageId
        for (var i in Object.keys(aaList)) {
          var key = '' + Object.values(aaList)[i]
          var index = _.findIndex(gblAbschlussart, function (o) {
            return o.id === '' + key && o.lanId === '' + language;
          });
          if (index !== -1) {
            this.aaList.push(gblAbschlussart[index])
          }
        }

        window.setTimeout(this.openTable, 1000)
      },
      close: function () {
        if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
          this.$refs.sdTable.doDestroyTable()
        }
      },
      filterHeader(headers) {
        let res = []
        console.log('headers', headers)
        var index = _.findIndex(headers, function (o) {
          var hit = ('aa' === o.meta.id)
          console.log('o', o, hit)
          return hit
        })
        if (index > -1) res.push(headers[index])
        index = _.findIndex(headers, function (o) {
          var hit = ('rk' === o.meta.id)
          return hit
        })
        if (index > -1) res.push(headers[index])
        index = _.findIndex(headers, function (o) {
          var hit = ('source' === o.meta.id)
          return hit
        })
        if (index > -1) res.push(headers[index])
        index = _.findIndex(headers, function (o) {
          var hit = ('year' === o.meta.id)
          return hit
        })
        if (index > -1) res.push(headers[index])
        return res
      },
      show(data) {
        console.log('showMe', data)
        this.onDataLoaded(0)
        this.akresultsDialog = data
        this.headItem = {
          name: data.table.rows[0].cells[0].co,
          balance: data.table.rows[0].balance,
          crefoNr: data.table.rows[0].balance.crefoNr
        }
        this.dialog = true
      },
      resetNear() {
        Vue.prototype.$api.debug('resetNear')
        this.dialog = false
        Vue.prototype.$eventHub.$emit('OnGetNearesBank', null)
      },
      getHint(item, head) {
        if (item && head && item[head.value]) {
          return item[head.value].tt
        }
        return ''
      },
      isNumber(s) {
        return this.numberRegex.test(s)
      },
      getValue(item, head) {
        if (item[head.value]) {
          var value = item[head.value].co
          var type = item.meta.type
          var format = item[head.value].format
          if (!format) {
            format = head.meta.format
            if (!format) {
              format = ''
            }
          }

          if ((head.meta.type === 'comp-icon') || (head.meta.type === 'comp-ref-icon') || (head.meta.type === 'trendicon')) {
            var color = 'textcolor-green'
            var i = item[head.value].co
            if (i === '') return ''
            if (i === 0) return ''
            var arrow = 'arrow_drop_up'
            if (i === -1) {
              arrow = 'arrow_drop_down'
              color = 'textcolor-red'
            }
            if (i === 1) arrow = 'arrow_drop_up'
            value = '<i aria-hidden="true" class="' + color + ' v-icon material-icons theme--light">' + arrow + '</i>'
            return value
          }

          if (value) {
            var valueBefore = value
            if ((format.toLowerCase() === '')) {
              return value
            }
            if ((format.toLowerCase() === 't')) {
              return value
            }
            if ((type === 'sp') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((type === 'raw') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            } else if ((type === 'kz') && this.isNumber(value)) {
              value = Vue.prototype.$api.convertToWaimeaDecimal(format, value)
            }
          }

          if (value === 'NaN') {
            Vue.prototype.$api.debug('valueBefore', valueBefore, value)
          }
          /*
          */
          var hint = this.getHint(item, head)
          var hasHint = hint != null && (hint.length > 0)
          if (hasHint) {
            if (this.tableConfig.hideHintStars) {

            } else {
              value = value + '<sup>*</sup>'
            }
          }
        }
        if (!value) value = ''
        if (value === 'undefined') value = ''
        return value
      },
      clear() {
        this.akresultsDialog = []
      },
      selectBank(data) {
        Vue.prototype.$api.debug('selectBank', data)
        this.dialog = false
        this.clear()
        Vue.prototype.$eventHub.$emit('OnGetNearesBank', data)
      },
      onGetHitListConfig(data) {
        this.headersDialog = data.array
        this.onDataLoaded(this.dataLoadedIndex + 1)
      },
      openWithoutBalance () {
        this.defBalance.rkNr = 0
        this.defBalance.source = 0
        this.defBalance.year = 0
        this.defBalance.aaNr = 0
        var url = '/Forward?url=' + Vue.prototype.$api.getStructureAnchorUrl(this.idModule, this.defBalance)
        Vue.prototype.$api.debug('url', url)
        this.dialog = false
        this.close()
        this.$router.push({ path:url, meta: {
            forward: true
          }})
      },
      onSelectItem(item) {
        Vue.prototype.$api.debug('click on ', item)
        var balance = item.meta.balance
        Vue.prototype.$api.debug('balance', balance)
        this.dialog = false
        Vue.prototype.$api.resetAll()
        this.close()
        this.idModule = Vue.prototype.$api.getModuleId()
        var url = '/Forward?url=' + Vue.prototype.$api.getStructureAnchorUrl(this.idModule, balance)
        Vue.prototype.$api.debug('url', url)
        this.$router.push({ path:url, meta: {
            forward: true
          }})

        // this.$router.push(Vue.prototype.$api.getStructureUrl(this.idModule, balance))
      },
      onDataLoaded(index) {
        Vue.prototype.$api.debug('onDataLoaded', index)
        if (index === 0) {
          Vue.prototype.$api.getAvailableHitListColumnsForUser(-1, -1, this.idModule, this.onGetHitListConfig)
        } else {
          this.open(this.akresultsDialog)
        }
        this.dataLoadedIndex = index
      }
    },
    created() {
      Vue.prototype.$eventHub.$on('clickOnNearestItem', this.onSelectItem)
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('clickOnNearestItem', this.onSelectItem)
    },
    mounted() {
      var cmp = this
      Vue.prototype.$api.checkCredentials(cmp, function () {
        if (cmp.$route.params) {
          cmp.idModule = cmp.$route.params.idModule
          cmp.idModuleItem = cmp.$route.params.idModuleItem
        }
        if (cmp.balanceName === 'Peergroup') {
          cmp.idModule = 'balances'
        }
        // this.onGetHitListDialogConfig(Vue.prototype.storage.configuration.configHitListDialog)
      })

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogNearestBanks.vue